import apiCalls from "../../config/apiCalls";
import headers from "../../config/headers";
import { keyMapsMutation } from "../../helpers/storeKeys";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import { apiEndpoints } from "../../config/apiEndpoints";

export default {
  namespaced: true,
  state: {
    showAlertModal: false,
    alertModalMsg: {
      msg: "Something went wrong. Please try again.",
      cta: "Dismiss",
    },
    dot20ModalFlag: false,
    dot20ModalData: "",
    showLoaderModal: false,
    deliveryTabValueForDeliveryEtaCase: "",
    isBottomNudgeVisible: false,
    splashScreenData: {},
    homepageCodeResumePromise: null,
    splashLottieJson: "",
    dominosPromiseData: {},
    showDominosPromiseShimmer: true,
    showDominosPromiseError: false,
  },
  getters: {
  },
  mutations: {
    updateDot20ModalFlag: (state, payload) => {
      state.dot20ModalFlag = payload;
    },
    updateDot20ModalData: (state, payload) => {
      state.dot20ModalData = payload;
    },
    updateAlertModalMsg: (state, payload) => {
      state.alertModalMsg = payload;
    },
    updateShowAlertModal: (state, payload) => {
      state.showAlertModal = payload;
    },
    updateShowLoaderModal: (state, payload) => {
      state.showLoaderModal = payload;
    },
    updateDeliveryTabValueForDeliveryEtaCase: (state, payload) => {
      state.deliveryTabValueForDeliveryEtaCase = payload;
    },
    updateIsBottomNudgeVisible: (state, payload) => {
      state.isBottomNudgeVisible = payload;
    },
    updateSplashScreenData(state, payload) {
      state.splashScreenData = payload?.response || {};
    },
    updateHomepageCodeResumePromise(state, payload) {
      state.homepageCodeResumePromise = payload;
    },
    updateDominosPromiseData(state, payload) {
      state.dominosPromiseData = payload || {};
    },
    updateShowDominosPromiseShimmer(state, payload) {
      state.showDominosPromiseShimmer = payload;
    },
    updateShowDominosPromiseError(state, payload) {
      state.showDominosPromiseError = payload;
    },
  },
  actions: {
    getDot20ModalData({ commit, state, dispatch }, payload) {
      const { orderDeliveryType, sgType } = payload;
      const value = LocalStorageFunc.getCoordsFromRecentLocation();
      const { latitude = "", longitude = "" } = value?.coords || {};
      const temp = {
        orderDeliveryType: orderDeliveryType,
        latitude: latitude,
        longitude: longitude,
        sgType: sgType,
      };
      apiCalls
        .GET_SERVICE_GUARANTEE_BREAKDOWN({
          headers: headers({ addtionalHeader: temp }, true),
        })
        .then((res) => {
          if (res?.data) {
            commit("updateShowLoaderModal", false);
            commit("updateDot20ModalData", res?.data);
            commit("updateDot20ModalFlag", true);
          } else {
            commit("updateShowLoaderModal", false);
            commit("updateShowAlertModal", true);
          }
        })
        .catch((error) => {
          commit("updateShowLoaderModal", false);
          commit("updateShowAlertModal", true);
        });
    },
    getSplashScreenData({ commit, rootGetters, state, dispatch }, payload) {
      return Promise.race([
        new Promise((resolve, reject) => {
          apiCalls
            .GET_SPLASH_SCREEN({
              headers: headers(),
              payload: payload,
            })
            .then(function (response) {
              if (response?.data) {
                commit("updateSplashScreenData", {
                  response: response?.data,
                });

                const splashData = response.data?.splash || [];
                const dataForNextApiLottie = splashData.find(
                  (obj) => obj?.subtype?.toLowerCase() === "lottie"
                );
                const dataForNextApiImage = splashData.find(
                  (obj) => obj?.subtype?.toLowerCase() === "image"
                );

                LocalStorageFunc.setLocalStorageValue(
                  "splashLottieUrl",
                  JSON.stringify(dataForNextApiLottie?.animation || "")
                );
                LocalStorageFunc.setLocalStorageValue(
                  "splashImageUrl",
                  JSON.stringify(dataForNextApiImage?.image1 || "")
                );
                LocalStorageFunc.setLocalStorageValue(
                  "splashImageTimer",
                  JSON.stringify(dataForNextApiImage?.props?.timer || 2)
                );

                if (dataForNextApiLottie?.animation) {
                  if (!payload.cachedFlowFlag) {
                    LocalStorageFunc.setSessionStorageKey("splashFlag", false);
                  }
                  return dispatch("getLottie", dataForNextApiLottie?.animation);
                } else if (dataForNextApiImage?.image1) {
                  if (!payload.cachedFlowFlag) {
                    LocalStorageFunc.setSessionStorageKey("splashFlag", false);
                  }
                  resolve({
                    apiSuccess: true,
                    data: dataForNextApiImage.image1,
                    isLottie: false,
                    timeOut: dataForNextApiImage?.props?.timer || 2,
                  });
                } else {
                  throw new Error(
                    "error : data error lottie/image both not found" + response
                  );
                }
              } else {
                LocalStorageFunc.setLocalStorageValue(
                  "splashLottieUrl",
                  JSON.stringify("")
                );
                LocalStorageFunc.setLocalStorageValue(
                  "splashImageUrl",
                  JSON.stringify("")
                );
                throw new Error("error reason for splash api " + response);
              }
            })
            .then(function (response) {
              if (response?.lottie) {
                if (response?.lottie) {
                  LocalStorageFunc.setLocalStorageValue(
                    "splashLottieJson",
                    JSON.stringify(response.lottie)
                  );
                  resolve({
                    apiSuccess: true,
                    data: response?.lottie,
                    isLottie: true,
                  });
                } else {
                  LocalStorageFunc.setLocalStorageValue("splashLottieJson", "");
                  throw new Error(
                    "got error while fetching lottie/image - no response " +
                      response
                  );
                }
              }
            })
            .catch(function (error) {
              console.log("error", error);
              reject({
                apiSuccess: false,
                error: error,
              });
            });
        }),
        Utility.timeoutPromise(1000),
      ]);
    },
    getLottie({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        apiCalls
          .GET_LOTTIE_DATA({
            headers: headers(),
            payload: payload,
          })
          .then((res) => {
            if (res?.data) {
              try {
                JSON.parse(JSON.stringify(res?.data));
              } catch (error) {
                throw new Error("Invalid JSON: ", error);
              }
              state.splashLottieJson = res.data;
              resolve({
                loattieDownloaded: true,
                lottie: res.data,
              });
            } else {
              throw new Error("error while fetching lottie no response");
            }
          })
          .catch((err) => {
            console.log("error while fetching splash lottie json", err);
            reject(err);
          });
      });
    },
    getDominosPromiseData({ commit, state, dispatch }, payload) {
      apiCalls
        .GET_BPG_DATA({
          headers: headers(),
          payload: payload,
        })
        .then((res) => {
          if (res?.data && res?.data?.groups?.length) {
            commit("updateDominosPromiseData", res?.data);
          } 
          else{
            commit("updateShowDominosPromiseError", true);
            commit("updateShowAlertModal", true);
          }
        })
        .catch((error) => {
          console.log(error);
          commit("updateShowDominosPromiseError", true);
          commit("updateShowAlertModal", true);
        })
        .finally(() => {
          commit("updateShowDominosPromiseShimmer", false);
        });
    },
  },
};
